import findIndex from 'lodash/findIndex';
import last from 'lodash/last';

export const filtroAlertas =  (state = 'todos', action) => {
  switch (action.type) {
    case 'CHANGE_STATE':
      return action.route.match(/marcadores/) ? last(action.route.split('/')) : state;
    default: return state;
  }
}

export const alertas = (state = [], action) => {
  switch (action.type) {
    case 'ALERTA_ENTERED':
      return [...state, action.alerta];
    case 'ALERTA_EXITED':
      const index = findIndex(state, {id: action.alerta.id});
      return [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ];
    case 'RESET_ALERTAS':
      return [];
    case 'ALERTA_MOVED':
    default: return state;
  }
};

export const listeningAlertas = (state = false, action) => {
  switch(action.type) {
    case 'TOGGLE_LISTENING_ALERTAS': return action.isListening;
    default: return state;
  }
}

export const alertaToastSelecionado = (state = {}, action) => {
  switch(action.type){
    case 'SELECIONA_TOAST_ALERTA':
      return action.alerta;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alertas.js